/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerComponents } from "../../../../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import PlayIcon from "../../../../../../shared/icons/player/Play.svg";
import { usePlayerCurrentMedia } from "../../../../../Controller";
import { useCustomPlayerContext } from "../../../../../CustomPlayerContext";
import {
  DropdownMenuItemExpandable,
  DropdownMenuSection,
  DropdownScrollableArea,
} from "../../../../Base";

import "./PlayList.scss";

export const PlayList = () => {
  const { media, playInfo } = usePlayerCurrentMedia();
  const { Button } = usePlayerComponents();
  const { t } = usePlayerTranslation();
  const { onNavigateToMedia } = useCustomPlayerContext();

  return (
    <DropdownMenuSection name="playlist">
      <DropdownScrollableArea>
        {playInfo?.Playlist?.map((mediaPlayInfo) => {
          return (
            <DropdownMenuItemExpandable
              key={mediaPlayInfo.MediaId}
              title={mediaPlayInfo.Title}
              orderInParent={mediaPlayInfo.MediaNo}
              active={media.Id == mediaPlayInfo.MediaId}
              onTitleClick={() => {
                if (
                  media.Id !== mediaPlayInfo.MediaId &&
                  mediaPlayInfo.MediaId
                ) {
                  onNavigateToMedia?.({ Id: mediaPlayInfo.MediaId });

                  return true;
                }

                return false;
              }}
            >
              <div className="PlayList__Content">
                <div className="PlayList__Content__Thumbnail">
                  {mediaPlayInfo?.ImageUrl ? (
                    <img
                      src={mediaPlayInfo.ImageUrl}
                      alt={mediaPlayInfo.Title || ""}
                      className="PlayList__image"
                    />
                  ) : null}
                  {media.Id !== mediaPlayInfo.MediaId && (
                    <div className="PlayList__Content__Thumbnail__Control">
                      <Button
                        variant="primary"
                        onClick={() => {
                          if (mediaPlayInfo.MediaId) {
                            onNavigateToMedia?.({ Id: mediaPlayInfo.MediaId });
                          }
                        }}
                        aria-label={
                          mediaPlayInfo.Title
                            ? `${t("PLAYER_TOOLTIP_PLAY")} ${
                                mediaPlayInfo.Title
                              }`
                            : t("PLAYER_TOOLTIP_PLAY")
                        }
                        iconOnly
                      >
                        <PlayIcon aria-hidden="true" focusable="false" />
                      </Button>
                    </div>
                  )}
                </div>
                <div className="PlayList__Content__Metadata">
                  <div
                    className="PlayList__Content__Metadata__Description"
                    dangerouslySetInnerHTML={{
                      __html: mediaPlayInfo.Description || "",
                    }}
                  />
                </div>
              </div>
            </DropdownMenuItemExpandable>
          );
        })}
      </DropdownScrollableArea>
    </DropdownMenuSection>
  );
};
